import { TMapTypeId as TMapTypeId$1, empty as empty$1, find as find$1, findSTM as findSTM$1, findAll as findAll$1, findAllSTM as findAllSTM$1, forEach as forEach$1, fromIterable as fromIterable$1, get as get$1, getOrElse as getOrElse$1, has as has$1, isEmpty as isEmpty$1, keys as keys$1, make as make$1, merge as merge$1, reduce as reduce$1, reduceSTM as reduceSTM$1, reduceWithIndex as reduceWithIndex$1, reduceWithIndexSTM as reduceWithIndexSTM$1, remove as remove$1, removeAll as removeAll$1, removeIf as removeIf$1, removeIfDiscard as removeIfDiscard$1, retainIf as retainIf$1, retainIfDiscard as retainIfDiscard$1, set as set$1, setIfAbsent as setIfAbsent$1, size as size$1, takeFirst as takeFirst$1, takeFirstSTM as takeFirstSTM$1, takeSome as takeSome$1, takeSomeSTM as takeSomeSTM$1, toArray, toHashMap as toHashMap$1, toReadonlyArray as toReadonlyArray$1, toReadonlyMap as toReadonlyMap$1, transform as transform$1, transformSTM as transformSTM$1, transformValues as transformValues$1, transformValuesSTM as transformValuesSTM$1, updateWith as updateWith$1, values as values$1 } from '../../internal/stm/tMap.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TMapTypeId = TMapTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Transactional map implemented on top of `TRef` and `TArray`. Resolves
 * conflicts via chaining.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Makes an empty `TMap`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * Finds the key/value pair matching the specified predicate, and uses the
 * provided function to extract a value out of it.
 *
 * @since 2.0.0
 * @category elements
 */
const find = find$1;

/**
 * Finds the key/value pair matching the specified predicate, and uses the
 * provided effectful function to extract a value out of it.
 *
 * @since 2.0.0
 * @category elements
 */
const findSTM = findSTM$1;

/**
 * Finds all the key/value pairs matching the specified predicate, and uses
 * the provided function to extract values out them.
 *
 * @since 2.0.0
 * @category elements
 */
const findAll = findAll$1;

/**
 * Finds all the key/value pairs matching the specified predicate, and uses
 * the provided effectful function to extract values out of them..
 *
 * @since 2.0.0
 * @category elements
 */
const findAllSTM = findAllSTM$1;

/**
 * Atomically performs transactional-effect for each binding present in map.
 *
 * @since 2.0.0
 * @category elements
 */
const forEach = forEach$1;

/**
 * Makes a new `TMap` initialized with provided iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = fromIterable$1;

/**
 * Retrieves value associated with given key.
 *
 * @since 2.0.0
 * @category elements
 */
const get = get$1;

/**
 * Retrieves value associated with given key or default value, in case the key
 * isn't present.
 *
 * @since 2.0.0
 * @category elements
 */
const getOrElse = getOrElse$1;

/**
 * Tests whether or not map contains a key.
 *
 * @since 2.0.0
 * @category elements
 */
const has = has$1;

/**
 * Tests if the map is empty or not.
 *
 * @since 2.0.0
 * @category getters
 */
const isEmpty = isEmpty$1;

/**
 * Collects all keys stored in map.
 *
 * @since 2.0.0
 * @category elements
 */
const keys = keys$1;

/**
 * Makes a new `TMap` that is initialized with specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * If the key is not already associated with a value, stores the provided value,
 * otherwise merge the existing value with the new one using function `f` and
 * store the result.
 *
 * @since 2.0.0
 * @category mutations
 */
const merge = merge$1;

/**
 * Atomically folds using a pure function.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce = reduce$1;

/**
 * Atomically folds using a transactional function.
 *
 * @since 2.0.0
 * @category folding
 */
const reduceSTM = reduceSTM$1;

/**
 * Atomically folds using a pure function.
 *
 * @since 2.0.0
 * @category folding
 */
const reduceWithIndex = reduceWithIndex$1;

/**
 * Atomically folds using a transactional function.
 *
 * @since 2.0.0
 * @category folding
 */
const reduceWithIndexSTM = reduceWithIndexSTM$1;

/**
 * Removes binding for given key.
 *
 * @since 2.0.0
 * @category mutations
 */
const remove = remove$1;

/**
 * Deletes all entries associated with the specified keys.
 *
 * @since 2.0.0
 * @category mutations
 */
const removeAll = removeAll$1;

/**
 * Removes bindings matching predicate and returns the removed entries.
 *
 * @since 2.0.0
 * @category mutations
 */
const removeIf = removeIf$1;

/**
 * Removes bindings matching predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
const removeIfDiscard = removeIfDiscard$1;

/**
 * Retains bindings matching predicate and returns removed bindings.
 *
 * @since 2.0.0
 * @category mutations
 */
const retainIf = retainIf$1;

/**
 * Retains bindings matching predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
const retainIfDiscard = retainIfDiscard$1;

/**
 * Stores new binding into the map.
 *
 * @since 2.0.0
 * @category mutations
 */
const set = set$1;

/**
 * Stores new binding in the map if it does not already exist.
 *
 * @since 2.0.0
 * @category mutations
 */
const setIfAbsent = setIfAbsent$1;

/**
 * Returns the number of bindings.
 *
 * @since 2.0.0
 * @category getters
 */
const size = size$1;

/**
 * Takes the first matching value, or retries until there is one.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeFirst = takeFirst$1;

/**
 * Takes the first matching value, or retries until there is one.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeFirstSTM = takeFirstSTM$1;

/**
 * Takes all matching values, or retries until there is at least one.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeSome = takeSome$1;

/**
 * Takes all matching values, or retries until there is at least one.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeSomeSTM = takeSomeSTM$1;

/**
 * Collects all bindings into a `Chunk`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toChunk = toArray;

/**
 * Collects all bindings into a `HashMap`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toHashMap = toHashMap$1;

/**
 * Collects all bindings into a `ReadonlyArray`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toReadonlyArray = toReadonlyArray$1;

/**
 * Collects all bindings into a `ReadonlyMap`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toReadonlyMap = toReadonlyMap$1;

/**
 * Atomically updates all bindings using a pure function.
 *
 * @since 2.0.0
 * @category mutations
 */
const transform = transform$1;

/**
 * Atomically updates all bindings using a transactional function.
 *
 * @since 2.0.0
 * @category mutations
 */
const transformSTM = transformSTM$1;

/**
 * Atomically updates all values using a pure function.
 *
 * @since 2.0.0
 * @category mutations
 */
const transformValues = transformValues$1;

/**
 * Atomically updates all values using a transactional function.
 *
 * @since 2.0.0
 * @category mutations
 */
const transformValuesSTM = transformValuesSTM$1;

/**
 * Updates the mapping for the specified key with the specified function,
 * which takes the current value of the key as an input, if it exists, and
 * either returns `Some` with a new value to indicate to update the value in
 * the map or `None` to remove the value from the map. Returns `Some` with the
 * updated value or `None` if the value was removed from the map.
 *
 * @since 2.0.0
 * @category mutations
 */
const updateWith = updateWith$1;

/**
 * Collects all values stored in map.
 *
 * @since 2.0.0
 * @category elements
 */
const values = values$1;

export { TMapTypeId, empty, find, findAll, findAllSTM, findSTM, forEach, fromIterable, get, getOrElse, has, isEmpty, keys, make, merge, reduce, reduceSTM, reduceWithIndex, reduceWithIndexSTM, remove, removeAll, removeIf, removeIfDiscard, retainIf, retainIfDiscard, set, setIfAbsent, size, takeFirst, takeFirstSTM, takeSome, takeSomeSTM, toChunk, toHashMap, toReadonlyArray, toReadonlyMap, transform, transformSTM, transformValues, transformValuesSTM, updateWith, values };
